import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Topbar from "../user/Topbar";
import Home from "./Home";
import Aboutus from "./Aboutus";
import Bookservices from "./Bookservices";
import Contactus from "./Contactus";
import Footer from "./Footer";
import Profile from "./Profile";
import AdminLayout from "../admin/AdminLayout";
import Login from "../user/Login";
import ProtectedRoute from "../../components/ProtectedRoute";
import ScrollToTop from "../ScrollToTop";

/* 🔹 Layout Component */
const Layout = () => {
  const location = useLocation();

  // ❌ Footer hide on these routes
  const hideFooterRoutes = ["/admin", "/login"];

  const hideFooter = hideFooterRoutes.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      <ScrollToTop />
      <Topbar />

      <Routes>
        {/* 🌐 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/bookservices" element={<Bookservices />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/login" element={<Login />} />

        {/* 🔒 User */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute type="user">
              <Profile />
            </ProtectedRoute>
          }
        />

        {/* 🔒 Admin */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute type="admin">
              <AdminLayout />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* ✅ Footer only for user pages */}
      {!hideFooter && <Footer />}
    </>
  );
};

/* 🔹 Main Router */
const Userroutes = () => {
  return (
    
      <Layout />
  );
};

export default Userroutes;
